import * as actionTypes from "./action-types";

export const setPageState = (pageState) => {
    return {
        type: actionTypes.SET_PAGE_STATE,
        ...pageState
    }
}